import fieldsArrSheet from 'fields/FieldsArrSheet';

export default {
  Literature: {
    // root
  },
  ...fieldsArrSheet,
};
